import React from "react";
import logoarc from './../assets/logo/logoarc.jpg';
import uow from './../assets/logo/uow.svg';

const Host = () => {
  const hosts = [
    {
      pic: logoarc,
      url: "https://arc-innovative-composites-sustainable-mining.org.au/",
      className: "md:w-64 w-48"  // Increased size for logoarc
    },
    {
      pic: uow,
      url: "https://www.uow.edu.au/",
      className: "md:w-48 w-36"  // Default size for other logos
    },
  ];

  return (
    <div className="flex flex-row flex-wrap content-start items-center justify-around">
      {hosts.map((host, index) => (
        <a href={host.url} key={`host-${index}`} className="hover:opacity-80" target="_blank" rel="noreferrer">
          <div className={host.className + " m-4 md:m-8"}>
            <img src={host.pic} alt={`logo-host-${index}`} className="w-full" />
          </div>
        </a>
      ))}
    </div>
  );
}

export default Host;